import React, { useState } from 'react';
import { Text, Input, Grid, Button, Dropdown } from '@nextui-org/react';
import axios from 'axios';
import swal from 'sweetalert';

export default function ElectricBill() {
  const [selected, setSelected] = React.useState(new Set(['Select  Location']));

  const selectedValue = React.useMemo(() => Array.from(selected).join(', ').replaceAll('_', ' '), [selected]);
  const [BillNumber, setBillNumber] = useState('');
  const [BillDate, setBillDate] = useState('');
  const [BillAmount, setBillAmount] = useState('');
  const [BillDueDate, setBillDueDate] = useState('');
  const [BillRecipt, setBillRecipt] = useState('');
  function guardarArchivo(e) {
    const file = e.target.files[0]; // the file
    const reader = new FileReader(); // this for convert to Base64
    reader.readAsDataURL(e.target.files[0]); // start conversion...
    // eslint-disable-next-line func-names
    reader.onload = function () { // .. once finished..
      const rawLog = reader.result.split(',')[1]; // extract only thee file data part
      const dataSend = { dataReq: { data: rawLog, name: file.name, type: file.type }, fname: 'uploadFilesToGoogleDrive' }; // preapre info to send to API
      fetch(
        'https://script.google.com/macros/s/AKfycbxcFjAFkEz7gtt40LFXZDnZl-VmH2_grsZ6DUbWTs9144mCQG5SPChppjU36nZyabYA/exec', // your AppsScript URL
        { method: 'POST', body: JSON.stringify(dataSend) },
      ) // send to Api
        .then((res) => res.json()).then((a) => {
          setBillRecipt((a.url));
          swal({
            title: 'File Uploaded!',
            text: `Check Link${a.url}`,
            icon: 'success',
            button: 'Continue',
          });
        }).catch((err) => swal({
          title: 'File Not Uploaded!',
          text: `error ${err}`,
          icon: 'error',
          button: 'Try Again',
        })); // Or Error in console
    };
  }
  const submitClick = async () => {
    await axios
      .post('https://gapi.nxtunicorns.com/api/bill', {
        BillNumber,
        BillDate,
        BillAmount,
        Billtype: 'Electricity',
        BillDueDate,
        BillRecipt,
        Location: selectedValue }, { headers: { 'Content-Type': 'application/json' } })
      .then((response) => {
        // eslint-disable-next-line no-console
        console.log(response);
        swal({
          title: 'Electricity Submitted SuccessFully!',
          text: 'Check Data Column',
          icon: 'success',
          button: 'Continue',
        });
      })
      .catch((err) => {
        swal({
          title: 'Error Empty Field!',
          text: `error ${err}`,
          icon: 'error',
          button: 'Check Again',
        });
      });
  };
  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Text
        h1
        size={30}
        css={{
          textGradient: '45deg, $blue600 -20%, $blue600 50%',
        }}
        weight="bold"
      >
        ELECTRICITY BILL ENTRY
      </Text>
      <Grid>
        <Input label="Bill Number" type="text" placeholder="Enter Bill Number" onChange={(e) => setBillNumber(e.target.value)} value={BillNumber} />
      </Grid>
      <Grid>
        <Input label="Bill Date" type="date" placeholder="Enter Bill Date" onChange={(e) => setBillDate(e.target.value)} value={BillDate} />
      </Grid>
      <Grid>
        <Input label="Bill Due Date" type="date" placeholder="Enter Due date" onChange={(e) => setBillDueDate(e.target.value)} value={BillDueDate} />
      </Grid>
      <p>Select Location</p>
      <Dropdown>
        <Dropdown.Button flat color="secondary" css={{ tt: 'capitalize' }}>
          {selectedValue}
        </Dropdown.Button>
        <Dropdown.Menu
          aria-label="Single selection actions"
          color="secondary"
          disallowEmptySelection
          selectionMode="single"
          selectedKeys={selected}
          onSelectionChange={setSelected}
        >
          <Dropdown.Item key="Bamboo Flat">Bamboo Flat</Dropdown.Item>
          <Dropdown.Item key="Aberdeen Bazar">Aberdeen Bazar</Dropdown.Item>
          <Dropdown.Item key="Diligpur">Diligpur</Dropdown.Item>
          <Dropdown.Item key="Bathu Basti">Bathu Basti</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown><br />
      <Grid>
        <Input label="Upload File" type="file" placeholder="Upload File" onChange={(e) => guardarArchivo(e)} />
      </Grid><br />
      <Grid>
        <Input label="Bill Amount" type="number" placeholder="Enter Amount in rs" onChange={(e) => setBillAmount(e.target.value)} value={BillAmount} />
      </Grid><br />
      <Grid>
        <Button shadow color="primary" auto onClick={submitClick}>Submit</Button>
      </Grid>
    </div>
  );
}
